module.exports = __webpack_public_path__ + "static/media/agreement.5f325455.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/agreement.png
// module id = 1582
// module chunks = 0